import { data } from 'autoprefixer';
import { analytics } from '../analytics';

export const TrackAmountChanges = {

    data() {
        return {
            scapeFirstRender: true,
        };
    },

    watch: {
        selectedAmount(newAmount, oldAmount) {

            if(this.scapeFirstRender) {
                this.scapeFirstRender = false;
                return;
            }

            analytics.marketPlaceSignUpEvents.changeAmount({
                loan_id: this.loan?.id ?? null,
                loan_status: this.loan?.status ?? null,
                user_id: this.loan?.user_id ?? this.user?.id ?? null,
                old_amount: oldAmount,
                new_amount: newAmount,
            });
        }
    }
};

export default TrackAmountChanges;

